import { render, staticRenderFns } from "./UploadFilePro.vue?vue&type=template&id=4e35ef2e&scoped=true&"
import script from "./UploadFilePro.vue?vue&type=script&lang=js&"
export * from "./UploadFilePro.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilePro.vue?vue&type=style&index=0&id=4e35ef2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e35ef2e",
  null
  
)

export default component.exports